
import React, { useState, useEffect } from "react";

function SelectComponent(props) {
    const [selectedItem, setSelectedItem] = useState(props.value || "")

    const handleSelectItem = (value) =>{

        setSelectedItem(value);

        props.handleInput({
            target: {
                id: props.id,
                value: value,
            }
        });
    };

    useEffect(() => {
        setSelectedItem(props.value || "")
    }, [props])
    


    return (
        <div className="mb-3" >

            <label htmlFor={props.id} className="form-label">{props.label}</label>

            {props.loading ? (
                <div className="px-2">
                    <div className="spinner-border text-success" role="status">
                        <span className="sr-only"></span>
                    </div>
                </div>
            ) : (
                    <select
                      
                    disabled={props.disabled}
                    value={props.value || ""}
                    onChange={(e) => { handleSelectItem(e.target.value) }} key={props.id} id={props.id}
                    className={`form-select custom-select-bg input-order ${selectedItem ? 'selected-input' : ''}`}>
                    <option  value="">{props.placeholder}</option>
                    {props.items && props.items.map((item, index) => (
                        <option  key={index} value={item.value}>{item.text}</option>
                    ))}
                </select>
            )}
        </div>
    );
}

export default SelectComponent;








